import React, { useState } from 'react';
import { trackEvent, TRACKING_ENUMS } from 'Utils/Analytics';
import { HTMLParser } from 'Utils/Parser';
import { logger } from 'Utils/Logger';
import { SmartLink } from 'Components/SmartLink';
import { PageSubTitle } from 'Components/Titles';
import { Markdown } from 'Components/Markdown';
import './FAQ.css';

export const FaqItem = ({ url = '', headline = '', text = '' }) => {
  const [show, setShow] = useState(false);
  const toggleAnswer = () => {
    if (!show) {
      trackEvent(TRACKING_ENUMS.EVENT_FAQ_BUTTON_CLICK, {
        page_item_title: headline,
      });
    }
    setShow(!show);
  };

  const defaultRenderer = {
    a: ({ href, children }) => {
      let url = null;
      try {
        url = new URL(href);
      } catch (error) {
        logger.error('FAQ URL Item', { href }, error);
      }
      if (url !== null) {
        return (
          <a href={href} className="faqURL" target="noopener noreferrer">
            {children}
          </a>
        );
      }
      return children;
    },
  };

  let answerType = HTMLParser(text.replace(/“/g, ''));
  answerType = <Markdown components={defaultRenderer}>{answerType}</Markdown>;

  if (url) {
    answerType = <SmartLink linkUrl={url} text={answerType} className="faqLink" reload />;
  }

  return (
    <li className="faqItem">
      <button type="button" className="faqContent" role="presentation" onClick={() => toggleAnswer()}>
        <span className="faqText">{headline}</span>
        <span className={`faqCross ${show ? 'rotate' : ''}`} />
      </button>
      <div className={`faqAnswer ${show ? 'show' : ''} `}>
        <div className="faqText">{answerType}</div>
      </div>
    </li>
  );
};

export const FAQ = ({ source = [], headline = '' }) => {
  return (
    <div className="faqContainer">
      <PageSubTitle text={headline} alignText="left" />
      <ul className="faqList">
        {source.map((faqItems, index) => (
          <FaqItem key={`faq-item-${index}`} {...faqItems} />
        ))}
      </ul>
    </div>
  );
};
